module.exports = __webpack_public_path__ + "img/ch52.d6627b21.jpg";